/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Krankenbeitrag1Inputs */



/**

* @param {_Field_Krankenbeitrag1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_krankenbeitrag1 = /** @type {((inputs?: _Field_Krankenbeitrag1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Krankenbeitrag1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Priv. Krankenversicherungsbeitrag")
});
export { _field_krankenbeitrag1 as "_field_krankenBeitrag" }